<div class="col-xs-12" ng-controller="AboutCtrl as about" ng-show="about.userProfile.description">
  <div class="page-content" ng-bind-html="about.userProfile.description | nl2br">
  </div>
</div>
